<template>
    <div style="background:#fff;">
        <div style="width:1400px; margin:0 auto; padding:10px 0;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item>{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item>{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="nsh3ce_ctrl_container nsh3ce">
            <!-- 标题 -->
            <div class="nsh3ce_ctrl_title">
                <!-- 刷新按钮 -->
                <div class="refresh_btn" title="刷新" @click="refresh"><a-icon type="sync" /></div>
            </div>

            <!-- 逆水寒实时 -->
            <div class="nsh3ce_realtime">
                <div class="realtime_item_container">
                    <div class="realtime_item" v-for="data in datas.realtime" :key="data.title">
                        <span>{{ data.title }}</span>
                        <span>{{ data.value | format}}</span>
                    </div>
                </div>
                <p class="realtime_tip">上方实时数据（包含下方分服玩家付费留存情况实时部分）每5分钟自动刷新，下方数据除每小时自动刷新</p>
            </div>

            <!-- 逆水寒board -->
            <div class="nsh3ce_board" v-for="(week, index) in datas.board" :key="`borad${index}`">
                <div class="board-item" v-for="(it, key) in week" :key="key">
                    <span class="server" v-show="it.server_num" title="开新服数">{{ it.server_num }}</span>
                    <p class="dt">{{ it.dt }}</p>
                    <p>登录账号：{{ it.login_acc | format }}</p>
                    <p>新增账号：{{ it.new_acc | format }}</p>
                    <p>{{ it.index }}留(622)：{{ it.liucun_22?it.liucun_22:'/' }} <span v-show="it.liucun_22">%</span></p>
                    <p v-if="it.index>9">{{ it.index-7}}留(629)：{{ it.liucun_29?it.liucun_29:'/' }} <span v-show="it.liucun_29">%</span></p>
                    <p v-if="it.index==9">次留(629)：{{ it.liucun_29?it.liucun_29:'/' }} <span v-show="it.liucun_29">%</span></p>
                    <p>622滚服率：{{ it.roll_ratio?it.roll_ratio:'/' }} <span v-show="it.roll_ratio">%</span></p>
                    <p>充值：{{ it.money | format }} <span v-show="it.money">元</span></p>
                    <p>消费：{{ it.use | format}} <span v-show="it.use">元</span></p>
                    <div class="liucun" v-if="it.lc_lc_1">
                        <p v-show="it.lc_lc_1">{{ it.dt_num }}新增次留：{{ it.lc_lc_1 }} <span v-show="it.lc_lc_1">%</span></p>
                        <p v-show="it.lc_lc_2">{{ it.dt_num }}新增三留：{{ it.lc_lc_2 }} <span v-show="it.lc_lc_2">%</span></p>
                        <p v-show="it.lc_lc_3">{{ it.dt_num }}新增四留：{{ it.lc_lc_3 }} <span v-show="it.lc_lc_3">%</span></p>
                        <p v-show="it.lc_lc_4">{{ it.dt_num }}新增五留：{{ it.lc_lc_4 }} <span v-show="it.lc_lc_4">%</span></p>
                        <p v-show="it.lc_lc_5">{{ it.dt_num }}新增六留：{{ it.lc_lc_5 }} <span v-show="it.lc_lc_5">%</span></p>
                        <p v-show="it.lc_lc_6">{{ it.dt_num }}新增七留：{{ it.lc_lc_6 }} <span v-show="it.lc_lc_6">%</span></p>
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div class="nsh3ce_ctrl_tables" v-for="(it,index) in datas.results" :key="`table${index}`" :style="{width:index==0?'1600px':'1500px'}">
                <div class="table_title">
                    <h2>{{ it.title }}</h2>
                </div>
                <DataTable :fields="it.thead" :datas="it.tbody" class="nsh3ce_ctrl_table" :paging="false"/>
                <div class="tips">
                    <p v-for="t in it.tips" :key="t">{{ t }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import DataTable from '@/components/common/datatable.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'nsh3ce_all',
    props: ['parent', 'name'],
    components: {
        DataTable,
    },
    mounted(){
        this.getData(1, false)
        this.getData(1, true)
        
        this.timer.normal = setInterval(() => {
            this.getData(0, false)
        }, 60 * 60 * 1000)

        this.timer.realtime = setInterval(() => {
            this.getData(0, true)
        }, 5 * 60 * 1000)
    },
    beforeDestroy() {
        clearInterval(this.timer.realtime)
        clearInterval(this.timer.normal)
    },
    data() {
        return {
            datas: {
                realtime:[],
                board: [],
                results: [],
            },
            timer: {
                realtime: null,
                normal: null
            }
        }
    },
    methods: {
        getData(firsttime, realtime) {
            if(!realtime) {
                this.loading = true
            }
            let params = {mode:'nsh3ce_all', firsttime}
            if(realtime) {
                params['type'] = 'realtime'
            }
            this.$service.query(this.queryId, params).then((data)=>{
                if(realtime) {
                    this.datas.realtime = data
                }
                else {
                    Object.assign(this.datas, data)
                }
                if(!realtime) {
                    this.loading = false
                }
            }).catch((data)=> {
                if(!realtime) {
                    this.loading = false
                }
            })
        },
        refresh() {
            this.getData(0, false)
            this.getData(0, true)
        }
    }
}
</script>
<style lang="less">
@width:1500px;

// 刷新按钮动画
@keyframes scale {
    0% {
        transform: scale(1);
        opacity: .7
    }
    50% {
        transform: scale(1.5);
        opacity: 0
    }
    99% {
      transform: scale(1);
      opacity: 0
    }
    100% {
        transform: scale(1);
        opacity: .7
    }
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg)
    }
}

.nsh3ce_ctrl_container {
    min-height: 700px;
    .nsh3ce_ctrl_content_container {
        width:@width;
        margin:0 auto;
    }
    .nsh3ce_ctrl_title {
        height:100px;
        width:100%;
        .refresh_btn {
            position:absolute;
            left: 50%;
            margin:25px 0 0 250px;
            width: 50px;
            height: 50px;
            text-align: center;
            cursor: pointer;
            border-width: 0;
            background-color: transparent;
            color: rgba(0, 0, 0, .3);

            i {
                font-size: 25px;
                line-height: 55px;
            }
            &:hover {
                animation: spin 2s infinite linear;
            }
            &:hover:after {
                animation: none;
            }
            &:after {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 50px;
                width: 50px;
                border-radius: 100%;
                border: 1px solid rgba(0, 0, 0, .3);
                animation: scale 2s ease infinite;
            }
        }
    }

    .nsh3ce_ctrl_tables {
        margin:0 auto;
        margin-top:20px;
        margin-bottom:30px;
        width: @width;
        .table_title {
            position: relative;
            text-align: center;
            margin:50px 0 30px 0;
            h2 {
                color: #a89371; 
                font-size:20px;
                &:before {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    left:0;
                    width:40%;
                    border-bottom: 1px solid #a89371;
                }
                &:after {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    right:0;
                    width:40%;
                    border-bottom: 1px solid #a89371;
                }
            }
        }
        .nsh3ce_ctrl_table {
            .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
                padding:5px 0;
                font-size:12px;
            }
            .ant-table-tbody > tr:nth-child(2n) td{
                background:#e9e9e9;
            }
            .ant-table-tbody > tr:hover td{
                background:#e6f7ff;
            }
            .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
                padding: 5px 0px;
                font-size:13px;
            }
        }
        .tips {
            margin:20px 0 0 0;
            color:#777;
            text-align: center;
        }
    }

    &.nsh3ce {
        background: url('../../../assets/img/ctrl/nsh/bg.jpg');
        .nsh3ce_ctrl_title {
            background: url('../../../assets/img/ctrl/nsh/3ce_title.png') center no-repeat;
        }
    }

    .nsh3ce_realtime {
        margin:20px 0 20px 0;
        .realtime_item_container {
            display: flex;
            justify-content: center;
            
            .realtime_item {
                border-radius: e('50%/50%');
                text-align: center;
                background-color: rgb(210, 179, 105);
                margin-right: 5px;
                color: #fff;
                span {
                    display: block;
                    padding: 7px 20px 3px 20px;
                    &:last-child {
                        padding: 3px 20px 7px 20px;
                        border-top: 1px solid #fff;
                    }
                }
            }
        }
        .realtime_tip {
            color: rgb(210, 179, 105);
            text-align: center;
            white-space: nowrap;
            margin:10px 0 0 0;
        }
    }

    @mainColor:#a89371;
        
    .nsh3ce_board {
        width:  1512px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        margin: 0 auto 30px;
        padding: 20px;
        border: 1px solid @mainColor;
        .legend {
            position: absolute;
            width: 18px;
            line-height: 1;
            left: -19px;
            top: -4px;
            min-height: 40px;
            padding: 2px;
            background-color: @mainColor;
            color: #fff;
            text-align: center;
        }
        .corner {
            @cornerWidth: 4px;
            position: absolute;
            height: @cornerWidth;
            width: 40px;
            background-color: @mainColor;
            &:after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 40px;
            width: @cornerWidth;
            background-color: @mainColor;
            }
            &:nth-of-type(1) {
            top: -@cornerWidth;
            left: -@cornerWidth;
            }
            &:nth-of-type(2) {
            bottom: -@cornerWidth;
            right: -@cornerWidth;
            transform: rotate(180deg);
            }
        }
        .liucun {
            border-top:1px solid #ddd;
            margin:10px 0;
            padding:10px 0;
        }
        .board-item {
            vertical-align: top;
            width:190px;
            min-height:150px;
            padding-bottom: 10px;
            margin:10px;
            background:rgba(200,200,200,0.1);
            color: #777;
            position: relative;
            .server {
                position: absolute;
                right: -6px;
                top: -6px;
                padding: 3px;
                background-color: #c40000;
                color: #fff;
                border-radius: 12px;
                font-size: 12px;
                line-height: 1;
            }
            .dt {
                width: 100%;
                height: 60px;
                margin-bottom: 20px;
                margin-left: 0;
                background-color: #eee;
                color: @mainColor;
                font-size: 18px;
                line-height: 60px;
                text-align: center;
            }
            p {
                margin:0 15px;
                line-height:24px;
                color:#777;
            }
        }
    }
}
</style>